import { Text } from '@change/ds-core-ui';
import { Form, TextArea, TextField } from '@change/ds-forms';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { StepActions } from '#src/app/pages/startAPetitionV2/shared/components';

import { ErrorScreen } from './components/ErrorScreen';
import { Loading } from './components/Loading';
import { usePersonalPrompt } from './hooks/usePersonalPrompt';

/**
 * `sap_ai_text_labeling` enabled-variant copy of the personal-story step (EU AI Act Art. 50 —
 * see docs/front-end/pages/startAPetitionV2/experiments/index.md — Step experiments). Renders the
 * control step with an AI-disclosure loading screen (see ./components/Loading).
 */
export const PersonalPrompt: React.FC = () => {
	const { translate } = useI18n();
	const { data, actions } = usePersonalPrompt();

	if (data.error) return <ErrorScreen />;

	if (data.loading) return <Loading />;

	return (
		<div
			className="container mx-auto mb-22 flex max-w-[620px] flex-col gap-6 px-5 py-8 md:gap-12"
			data-qa="personal-prompt"
		>
			<div className="grid gap-4">
				<Text as="h1" variant="heading" className="m-0">
					<Translate value="corgi.start_a_petition.personal_prompt.heading" />
				</Text>

				<Text as="p" variant="body" size="large">
					<Translate value="corgi.start_a_petition.personal_prompt.description" />
				</Text>
			</div>

			<Form
				onSubmit={actions.submit}
				schema={data.schema}
				defaultValues={data.defaultValues}
				className="grid gap-6 md:gap-12"
				data-qa="issue-prompt-form"
			>
				<TextField
					name="personalStory"
					size="large"
					boldLabel
					maxLength={500}
					label={translate('corgi.start_a_petition.personal_prompt.personal_story_input_label')}
					placeholder={translate('corgi.start_a_petition.personal_prompt.personal_story_input_placeholder')}
					onBlur={actions.persistDraft}
					input={<TextArea />}
				/>

				<StepActions type="form" onSecondaryAction={actions.back} />
			</Form>
		</div>
	);
};
